import i18next from 'i18next/i18next';
import { TranslationKey } from 'i18next/resources';

const errorCodesTranslationKeyMap: Record<number, TranslationKey> = {
  10000: 'reg_shield.error10000',
  10005: 'reg_shield.error10005',
  10006: 'reg_shield.error10006',
  10009: 'reg_shield.error10009',
  10010: 'reg_shield.error10010',
  10012: 'reg_shield.error10012',
  10015: 'reg_shield.error10015',
  10016: 'reg_shield.error10016',
  10017: 'reg_shield.error10017',
  11000: 'reg_shield.error11000',
  30000: 'reg_shield.error30000',
  90000: 'reg_shield.error90000'
};

export const getErrorMessage = (code: number, traceId: string) => {
  let errorMessage: TranslationKey = 'reg_shield.error_try_again';

  if (errorCodesTranslationKeyMap[code]) {
    errorMessage = errorCodesTranslationKeyMap[code];
  } else if (code >= 20000 && code < 30000) {
    errorMessage = 'reg_shield.error20XXX';
  } else if (code >= 40000 && code < 50000) {
    errorMessage = 'reg_shield.error40XXX';
  }

  return `${i18next.t(errorMessage)}<br><br>
     <strong>Trace ID: ${traceId} </strong>
    `;
};
